import { FC, ReactNode } from "react";
import Text from "~/components/Text";

interface VariantItemProps {
  title?: string;
  children?: ReactNode;
  extra?: ReactNode;
  value?: any;
}

const VariantItem: FC<VariantItemProps> = ({
  title,
  children,
  extra,
  value,
}) => {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <div className="flex gap-2">
          <Text type="body-1" className="font-semibold">
            {title}:
          </Text>
          <Text type="body-1" className="text-gray-500">
            {value}
          </Text>
        </div>
        {extra}
      </div>
      {children}
    </div>
  );
};

export default VariantItem;
